// extracted by mini-css-extract-plugin
module.exports = {"title":"PopularBrandsSection_title__xvLlA","container":"PopularBrandsSection_container___5qtC"};